<template>
    <div style="display: flex; flex-direction: column;">
        <MercenaryHeader :title="'신고내역 전체보기'" :back-title="'뒤로가기'" :close-action="() => { $GlobalStore.closeLastModal() }">
        </MercenaryHeader>
        <div style="flex: 1; overflow: hidden;">
            <InfinityScroll style="height: 100%;" :isEnableNextPageHandle="isEnableNextPageHandle" :handle-next-page="handleNextPage" :refresh-action="() => { }">
                <div style="padding: 0 12px;">
                    <div @click="showHistoryDetail(each)" v-for="each, i in reportList" :key="i" style="display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid #ebebeb; padding-bottom: 8px; padding-top: 12px;">
                        <div>
                            <div style="display: flex; align-items: center; gap: 4px; margin-bottom: 5px; font-size: 12px; font-weight: 500; color: #606060;">
                                <div style="line-height: 20px;">{{ transDate(each.insert_date) }}</div>
                                <div style="width: 2px; height: 2px; background-color: #606060; border-radius: 50%;"></div>
                                <div style="line-height: 20px;">{{ transTitle(each.refer_type) }}</div>
                            </div>
                            <div v-if="each.refer_type == REPORT_TYPE_IDX.SOCCERHOW_ANYONE || each.refer_type == REPORT_TYPE_IDX.SOCCERHOW_COACH" style="font-weight: 500; font-size: 14px; line-height: 24px;"><span style="font-weight: 700;">{{ each.target_nic_name }}</span>님의 게시물을 신고했습니다.</div>
                            <div v-else-if="each.refer_type == REPORT_TYPE_IDX.SCHEDULE" style="font-weight: 500; font-size: 14px; line-height: 24px;"><span style="font-weight: 700;">{{ each.report_title }}</span>스케줄을 신고했습니다.</div>
                            <div v-if="each.refer_type == REPORT_TYPE_IDX.JOIN" style="font-weight: 500; font-size: 14px; line-height: 24px;"><span style="font-weight: 700;">{{ each.report_title }}</span>멤버톡을 신고했습니다.</div>
                        </div>
                        <div>
                            <img :src="require('@/assets/images/mypage/ico-move.png')" style="width:10px;">
                        </div>
                    </div>
                </div>
            </InfinityScroll>
        </div>
    </div>
</template>

<script>
import MercenaryHeader from "@/components/common/MercenaryHeader";
import InfinityScroll from "@/components/common/InfinityScroll"
import { REPORT_TYPE_IDX } from "@/Constants"

export default {
    name: 'ReportHistoryNew',
    components: { MercenaryHeader, InfinityScroll },
    data() {
        return {
            reportList: [],
            isEnableNextPageHandle: true,
            page: 1,
            REPORT_TYPE_IDX: REPORT_TYPE_IDX
        }
    },
    methods: {
        async getReportList() {
            this.isEnableNextPageHandle = false;
            const parameters = {}
            parameters.page = this.page;
            parameters.report_type =[REPORT_TYPE_IDX.JOIN, REPORT_TYPE_IDX.SCHEDULE, REPORT_TYPE_IDX.SOCCERHOW_ANYONE, REPORT_TYPE_IDX.SOCCERHOW_COACH]

            const res = await this.$Axios.get('/api/report/list', { params: parameters })
            const reports = res.data.reports

            if (reports.length > 0) {
                this.isEnableNextPageHandle = true;
                this.reportList = [...this.reportList, ...reports];
            }

        },
        showHistoryDetail(historyDetail) {
            this.$GlobalStore.addModal('ReportHistoryDetail', {historyDetail: historyDetail})
        },
        handleNextPage() {
            this.page++
            this.getReportList()
        },
        transDate(date) {
            let transDate = date.split(' ')
            transDate = transDate[0].split('-').splice(1, 2)
            return `${transDate[0]}월 ${transDate[1]}일`
        },
        transTitle(refer_type) {
            switch (parseInt(refer_type)) {
                case REPORT_TYPE_IDX.SCHEDULE:
                    return '스케줄';
                case REPORT_TYPE_IDX.JOIN:
                    return '멤버톡'
                case REPORT_TYPE_IDX.SOCCERHOW_ANYONE:
                case REPORT_TYPE_IDX.SOCCERHOW_COACH:
                    return '하우'
                case REPORT_TYPE_IDX.JOIN_COMMUNITY:
                    return '커뮤니티'
                case REPORT_TYPE_IDX.PROFILE:
                    return '프로필'
            }
            // return refer_type
        }
    },
    created() {
        this.getReportList()
    }
}
</script>

<style scoped>
.circle {
    width: 5px;
    height: 5px;
    background-color: #210f03;
    border-radius: 50%;
}
</style>